
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/infiltration/vault",
      function () {
        return require("private-next-pages/infiltration/vault.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/infiltration/vault"])
      });
    }
  